import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import Img from 'gatsby-image'

import { ZIndex } from '../../../themes/Metrics'
import { Box, FlexBox } from '../../common/Box'
import { px2Rem } from '../../../themes/Mixins'
import { BtnPlay } from './BannerResponsive'
import COLORS from '../../../themes/Colors'
import IMAGES from '../../../themes/Image'
import Button from '../../common/Button'
import MainTitle from './MainTitle'

class Banner extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { banner, handleShowVideoPopup, handleToggleModal } = this.props

    return (
      <Box
        position='relative'
        width='100%'
        height={`${100 / 1.8}vw`}
      >
        <FlexBox
          onClick={() => { handleShowVideoPopup() }}
          width='100%'
          height='100%'
          position='absolute'
          alignItems='center'
          flexDirection='column'
          justifyContent='center'
          bgColor={COLORS.bgBanner}
          customStyle={{
            zIndex: `${ZIndex.medium}`
          }}
        >
          <MainTitle
            type='xxLarge'
            title={`Fantasy Drives Creativity \n If you can imagine it, we can build it`}
          />
          <BtnPlay
            text='play'
            onPress={(e) => {
              handleShowVideoPopup()
              e.stopPropagation()
            }}
            customStyle={{
              backgroundImage: `url(${IMAGES.btnPlay})`,
              backgroundColor: 'transparent',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: '100% 100%',
              borderRadius: '50%',
              padding: '0',
              textIndent: '-9999px'
            }}
          />
          {
            // Status of button get started is hide
          }
          <MediaQuery minWidth={768}>
            {(matches) => {
              return (
                matches ?
                  <Button
                    type='default'
                    text='Get Started'
                    onPress={(e) => {
                      handleToggleModal()
                      e.stopPropagation()
                    }}
                    customStyle={{
                      border: 'none',
                      display: 'none',
                      color: COLORS.white,
                      marginTop: `${px2Rem(80)}`,
                      backgroundColor: COLORS.red,
                    }}
                  />
                  : null
              )
            }}
          </MediaQuery>
        </FlexBox>
        <Img
          outerWrapperClassName='banner-thumbnail'
          sizes={banner.sizes}
        />
      </Box>
    )
  }
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/sections/banner/Banner.js